export const Imagegallery = () => {
    return (
        <section class="roservice">
            <div class="container">
                <h2>Water Purifier Services &amp;RO Repair &amp; RO Installation Repair Provider</h2>
                <div class="row">
                    <div class="col-md-4">
                        <div class="service1">
                            <img src="img/imagegallery/rorepair.jpg" class="img-fluid" alt="ro service in hyderabad" />
                            <div class="backser">
                                <h3>Ro Repair</h3>
                                <p>Regular servicing of your RO system is crucial to maintain its performance and longevity. Our trained technicians in hyderabad are equipped to handle comprehensive RO servicing, including filter replacement, membrane cleaning, and checking for any leaks or malfunctions. We offer scheduled maintenance plans tailored to your needs, ensuring your RO system continues to deliver safe and pure drinking water.</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="service1">
                            <img src="img/imagegallery/roinstall.jpg" class="img-fluid" alt="ro repair in hyderabad" />
                            <div class="backser">
                                <h3>Ro Installation</h3>
                                <p>Installing a Reverse Osmosis (RO) system is essential for ensuring clean and safe drinking water in your home or office. At RO Care Service, we provide professional RO installation in hyderabad to help you set up your water purification system quickly and efficiently.</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="service1">
                            <img src="img/imagegallery/roservice21.png" class="img-fluid" alt="aquaguard ro service in hyderabad" />
                            <div class="backser">
                                <h3>Water Quality Check</h3>
                                <p>Reliable and comprehensive water quality testing services across Hyderabad. Our team of experts conducts detailed assessments to ensure that your water is safe for consumption and meets all health standards.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}